const routes = {
  createProduct: 'item',
  getProducts: 'item',
  getProductById: 'item/',
  updateProduct: 'item/',
  deleteProduct: 'item/',
  addInventory: 'inventory',
  inventoryAdjustment: 'inventory-adjustments/bulk',
  updateVariants: 'item/',
  deleteVariant: 'item/variant/',
};

export default routes